import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var NoResults = styled.small.withConfig({
  displayName: "partials__NoResults",
  componentId: "sc-1apqrsr-0"
})(["", ";color:", ";"], getFont(-1, 'compact'), function (_ref) {
  var theme = _ref.theme,
    light = _ref.light;
  return light ? theme.colors.fontL : 'currentColor';
});